// extracted by mini-css-extract-plugin
export default {"container":"Ta0jY2","loading":"yfiHu_"};